<template>
  <div>
    <v-expansion-panel v-model="panel" expand>
      <v-expansion-panel-content>
        <template v-slot:header>
          <div>Detalhes da Fatura</div>
        </template>
        <v-card elevation="0">
          <v-data-table
            hide-actions
            class="elevation-5 my-4 mx-1 custom-table"
            no-data-text="Não há registros"
            rows-per-page-text="Linhas por página"
            item-key="numero"
            :headers="headersFatura"
            :expand="expanded"
            :items="visualizaParcelamento.faturas"
            :loading="isLoading"
          >
            <template v-slot:items="props">
              <tr
                :class="{ 'table-fatura-expanded': props.expanded }"
                @click="props.expanded = !props.expanded"
              >
                <td>{{ props.item.numero }}</td>
                <td>{{ props.item.emissao }}</td>
                <td>{{ props.item.vencimento }}</td>
                <td>{{ `R$ ${props.item.saldo || "0"}` }}</td>
                <td>{{ props.item.nomeSacado }}</td>
                <td>{{ `R$ ${props.item.imposto || "0"}` }}</td>
                <td>{{ `R$ ${props.item.juros || "0"}` }}</td>
                <td>{{ `R$ ${props.item.multa || "0"}` }}</td>
              </tr>
            </template>
            <template v-slot:expand="{ item }">
              <v-card flat>
                <v-data-table
                  hide-actions
                  no-data-text="Não há registros"
                  rows-per-page-text="Linhas por página"
                  item-key="id"
                  :headers="headersParcelas"
                  :expand="expanded"
                  :items="item.parcelas"
                  :loading="isLoading"
                >
                  <template v-slot:items="props">
                    <tr
                      :class="{ 'table-fatura-expanded': props.expanded }"
                      @click="props.expanded = !props.expanded"
                    >
                      <td>{{ props.item.notaRecebimento }}</td>
                      <td>{{ props.item.numeroParcela }}</td>
                      <td>{{ props.item.vencimento }}</td>
                      <td>{{ props.item.percentualJuros }}</td>
                      <td>{{ `R$ ${props.item.valorJuros || "0"}` }}</td>
                      <td>{{ `R$ ${props.item.valorImpostos || "0"}` }}</td>
                      <td>{{ `R$ ${props.item.valorLiquido || "0"}` }}</td>
                      <td>{{ `R$ ${props.item.valorJurosDetalhe || "0"}` }}</td>
                      <td>{{ props.item.percentualMulta }}</td>
                      <td>{{ `R$ ${props.item.valorMultaDetalhe || "0"}` }}</td>
                      <td>{{ `R$ ${props.item.valorParcela || "0"}` }}</td>
                      <td v-if="props.item.linkBoleto">
                        <v-tooltip z-index="999" left>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              icon
                              @click="
                                onClickBaixarBoleto(props.item.linkBoleto)
                              "
                            >
                              <v-icon>
                                download
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Download do boleto</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </template>
                  <template v-slot:expand="{ item }">
                    <v-card flat>
                      <v-data-table
                        hide-actions
                        no-data-text="Não há registros"
                        rows-per-page-text="Linhas por página"
                        item-key="cartaoBeneficiario"
                        :headers="headersDetalhes"
                        :items="item.detalhes"
                        :loading="isLoading"
                      >
                        <template v-slot:items="props3">
                          <td>{{ props3.item.cartaoBeneficiario }}</td>
                          <td>{{ props3.item.nomeBeneficiario }}</td>
                          <td>
                            {{ `R$ ${props3.item.valorOriginal || "0"}` }}
                          </td>
                          <td>{{ `R$ ${props3.item.valorParcela || "0"}` }}</td>
                          <td>{{ `R$ ${props3.item.valorJuros || "0"}` }}</td>
                          <td>{{ `R$ ${props3.item.valorMulta || "0"}` }}</td>
                          <td>{{ `R$ ${props3.item.valorFinal || "0"}` }}</td>
                        </template>
                      </v-data-table>
                    </v-card>
                  </template>
                </v-data-table>
              </v-card>
            </template>
          </v-data-table>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import { headersFatura, headersParcelas, headersDetalhes } from "./contants";
export default {
  name: "VisualizarParcelamento",
  props: {
    numberOfElementsVisualizaParcelamento: String,
    visualizaParcelamento: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isLoading: false,
      expanded: true,
      panel: [true],
      headersFatura,
      headersParcelas,
      headersDetalhes
    };
  },
  methods: {
    onClickBaixarBoleto(url) {
      window.open(url);
    }
  }
};
</script>
<style lang="scss" scoped>
.table-fatura-expanded {
  box-shadow: inset 0 0 0 1px #411564 !important;
  background-color: #f0f0f0;
}

.v-datatable td {
  padding: 0 8px !important;
}
</style>
